import React, { useState } from "react";
import { RemoveScroll } from "react-remove-scroll";
import SearchBar from "../SearchBar";
import ResponsiveFiltersBar, { ApplyButton } from "../ResponsiveFiltersBar";

import "./CruiseFilter.scss";
import SetFiltersButton from "../SetFiltersButton";
import { t, Plural } from "@lingui/macro";
import { FindYourCruiseFiltersProps } from "components/FindYourCruise";
import classNames from "classnames";

export interface CruiseFiltersProps extends FindYourCruiseFiltersProps {
  openFiltersAppliedFiltersButtonLabel?: string | JSX.Element;
  openFiltersButtonLabel?: string | JSX.Element;
  modalApplyButton?: JSX.Element;
}

const CruiseFilters: React.FC<CruiseFiltersProps> = ({
  showFreeTextSearch,
  openFiltersAppliedFiltersButtonLabel,
  openFiltersButtonLabel,
  modalApplyButton,
  ...filterProps
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openFilterModal = () => {
    setModalIsOpen(true);
  };

  const closeFilterModal = () => {
    setModalIsOpen(false);
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        return false;
      }}
      name="fyc"
    >
      <div className="ssc-filters">
        {showFreeTextSearch && (
          <div className="ssc-filters__search">
            <SearchBar placeholder={t`Search by port, voyage number...`} />
          </div>
        )}
        <SetFiltersButton
          onClick={openFilterModal}
          appliedFiltersButtonLabel={openFiltersAppliedFiltersButtonLabel}
          filtersButtonLabel={openFiltersButtonLabel}
          className="ssc-filters__open-modal-button"
        />

        <div
          className={classNames({
            "ssc-filters__filter-bar": true,
            "ssc-filters__filter-bar-with-search": showFreeTextSearch
          })}
        >
          <RemoveScroll enabled={modalIsOpen}>
            <ResponsiveFiltersBar
              modalIsOpen={modalIsOpen}
              modalCloseClick={closeFilterModal}
              applyButton={
                modalApplyButton ? (
                  modalApplyButton
                ) : (
                  <ApplyButton
                    onClick={closeFilterModal}
                    label={(appliedFiltersCount, resultsFoundCount) =>
                      appliedFiltersCount && appliedFiltersCount > 0 ? (
                        <Plural
                          value={resultsFoundCount}
                          one="View # Cruise"
                          other="View # Cruises"
                        />
                      ) : (
                        <Plural
                          value={resultsFoundCount}
                          one="Back to # Cruise"
                          other="Back to # Cruises"
                        />
                      )
                    }
                  />
                )
              }
              {...filterProps}
            />
          </RemoveScroll>
        </div>
      </div>
    </form>
  );
};

export default CruiseFilters;
